/* For pagination component that takes in pageCount, set result count to
1000 if max count on backend is met. This forces the user to narrow their
search criteria.*/

// Doesn't appear that there's any situation where result_count is not a number, so we can remove parseInt and type accordingly.
export const calculatePageCount = (result_count: number, results_per_page: number): number => {
  if (isNaN(result_count)) {
    return Math.ceil(1000 / results_per_page);
  }
  return Math.ceil(result_count / results_per_page);
};
